import React, { useEffect } from 'react';

import { Container, Grid } from '@mui/material';

import AccountSection from '@steamhub/pages/profile/account-section';
import LogoutSection from '@steamhub/pages/profile/logout-section';
import ClassroomsSection from '@steamhub/pages/profile/classrooms-section';
import TeacherCodeSection from '@steamhub/pages/profile/teacher-code-section';

import { useNav } from '@lib/hooks/index';
import { useAuth } from '@lib/auth';

const Profile = () => {
  const { setPage } = useNav();
  const { user } = useAuth();

  useEffect(() => {
    setPage('profile');
  }, []);

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AccountSection />
        </Grid>

        {/*<Grid item xs={12} sx={{ mt: 4 }}>*/}
        {/*  <SchoolSection />*/}
        {/*</Grid>*/}

        {user.role === 'teacher' && (
          <>
            <Grid item xs={12} sx={{ mt: 4 }}>
              <TeacherCodeSection />
            </Grid>
            <Grid item xs={12} sx={{ mt: 4 }}>
              <ClassroomsSection />
            </Grid>
          </>
        )}

        <Grid item xs={12} sx={{ mt: 6 }}>
          <LogoutSection context="steamhub" />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Profile;
